import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../component/sidebar";
import { Grid, Typography } from "@mui/material";
import Header from "../../component/header";
import BasicTable from "../tables/BasicTable";
import {
  useGetImageGallerysQuery,
  useUpdateImageGalleryMutation,
  useDeleteImageGalleryMutation,
  useAddImageGalleryMutation,
} from "../../../../services/imageGallerySlice";
import ImageGalleryAddButton from "./imageGalleryAddButton";
import { Box } from "@mui/system";

const DashboardImageGallerys = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <DashboardImageGallerysPages />
      </Grid>
    </Grid>
  );
};

const DashboardImageGallerysPages = () => {
  const { data, isLoading, isSuccess, isError, error } =
    useGetImageGallerysQuery("getImageGallerys");

  const [deleteImageGallery] = useDeleteImageGalleryMutation();

  const deleteConfirm = (e, id) => {
    e.preventDefault();
    console.log(id);
    deleteImageGallery({ id });
  };

  let headers = [];
  let tableData = [];
  let content;
  if (isLoading) {
    content = <p>"Loading..."</p>;
  } else if (isSuccess) {
    headers = ["Image", "Active"];
    tableData = [];
    data.ids.forEach((key) => {
      tableData.push({
        Image: data.entities[key].image,
        id: data.entities[key].id,
        Active: data.entities[key].is_active,
      });
    });
  }
  return (
    <>
      <Box className="table-design-background">
        <Grid container>
          <Grid item xs={6}>
            <Typography className="dashboard-home-page-text">
              Gallery Lists
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Link to="/dashboard/new/image-gallerys" style={{textDecoration:'none'}}>
              <ImageGalleryAddButton />
            </Link>
          </Grid>
        </Grid>
        <Box style={{ padding: "1.5rem" }}>
          <BasicTable
            headers={headers}
            data={tableData}
            isDelete={true}
            deleteColor={"#f50057"}
            isEdit={true}
            editColor={"#3f51b5"}
            addColor={""}
            tableName={"image-gallerys"}
            deleteConfirm={deleteConfirm}
            activeSign={["Active"]}
          />
        </Box>
      </Box>
    </>
  );
};
export default DashboardImageGallerys;
